import { useCoarsePointer } from "@heroncendre/player";
import { SelecteurLangue } from "../SelecteurLangue.js";
import { BoutonInfos } from "./BoutonInfos.js";
import { groupeVerre } from "./infosStyles.js";

/**
 * ============================================================================
 *  EnteteInfos.tsx — Le coin haut droit de la visite libre (ordinateur)
 * ----------------------------------------------------------------------------
 *  Le sélecteur FR / EN et, à sa droite, le bouton ⓘ de 44 px : un même groupe en verre
 *  dépoli (handoff `design_handoff_credits`, 9a).
 *
 *  Sur téléphone il n'y a rien ici : la langue est dans la feuille du menu, et le bouton ⋯
 *  est dans la barre de navigation du bas (`SceneNav`). Aucun bouton n'est ajouté en haut.
 * ==========================================================================*/

export function EnteteInfos() {
  const mobile = useCoarsePointer();
  if (mobile) return null;

  return (
    <div style={{ position: "absolute", top: 12, right: 12 }}>
      <div style={groupeVerre}>
        <SelecteurLangue />
        <BoutonInfos variante="info" habillage="groupe" />
      </div>
    </div>
  );
}
